/**
 * 订单合同页面圆角与样式配置，可按需调整数值。
 */
export const OrderContractStyle = {
  /** 订单卡片圆角 */
  cardBorderRadius: '8px',
  /** 商品/头像图片圆角 */
  imageBorderRadius: '6px',
  /** 按钮圆角 */
  buttonBorderRadius: '6px',
  /** 合同数量徽章圆角 */
  badgeBorderRadius: '4px',
  /** 规格标签圆角 */
  tagBorderRadius: '4px',
  /** 头像圆角（圆形） */
  avatarBorderRadius: '50%',
  /** 合同卡片圆角 */
  contractCardBorderRadius: '8px',
  /** 弹窗圆角 */
  modalBorderRadius: '8px',
  /** PDF 预览弹框圆角 */
  pdfPreviewModalBorderRadius: '12px',
};
